import * as React from "react";

import {
  ReactCheckout2022Route,
  ReactCheckout2022RouteHash,
  useReactCheckout2022Router,
} from "../providers";

export const HeaderBackButton: React.FunctionComponent = () => {
  const { currentRoute } = useReactCheckout2022Router();

  const label = React.useMemo(() => {
    switch (currentRoute) {
      case ReactCheckout2022Route.mybag:
        return "Continue Shopping";
      case ReactCheckout2022Route.delivery_details:
        return "Back to My Bag";
      case ReactCheckout2022Route.payment:
        return "Back to Delivery Details";
      default:
        return "Continue Shopping";
    }
  }, [currentRoute]);

  const href = React.useMemo(() => {
    switch (currentRoute) {
      case ReactCheckout2022Route.mybag:
        return "/";
      case ReactCheckout2022Route.delivery_details:
        return `${ReactCheckout2022RouteHash.MYBAG}`;
      case ReactCheckout2022Route.payment:
        return `${ReactCheckout2022RouteHash.delivery_details}`;
      default:
        return "/";
    }
  }, [currentRoute]);

  return (
    <React.Fragment>
      <a className="continue-shopping" href={href}>
        <p>{label}</p>
      </a>
    </React.Fragment>
  );
};
